import { Flex, Group, Image, SimpleGrid, Stack, Text } from "@mantine/core";
import Link from "next/link";
import styles from "./footer4.module.scss";
import { useMediaQuery } from "usehooks-ts";

export default function Footer4({ options, logo, logoHref, maxWidth }) {
  const isThreshold = useMediaQuery(`(max-width:${1000}px`);
  const isMobile = useMediaQuery(`(max-width:${550}px`);
  const footerStyles = options.styles;

  const mainStyle = {
    width: "100%",
    color: "#031F6D",
    background: "#E1EDFB",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  const logoStyle = {
    width: 200,
    height: "auto",
  };

  const descriptionTitleStyle = {
    fontSize: 16,
    fontWeight: "bolder",
  };

  const descriptionTextStyle = {
    fontSize: 14,
  };

  const connectItemWrapperStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    gap: 20
  }

  return (
    <div
      className={styles.footer3}
      style={{
        ...mainStyle,
        ...(footerStyles?.main || {}),
      }}
    >
      <Flex
        w={maxWidth && !isThreshold ? maxWidth : "100%"}
        gap={40}
        px={isThreshold ? 24 : 48}
        direction={isThreshold ? "column" : "row"}
      >
        <Link href={logoHref || ""} target="_blank">
          <Image
            alt=""
            style={{
              ...logoStyle,
              ...(footerStyles?.logo || {}),
            }}
            src={options.logo || logo}
          />
        </Link>

        <SimpleGrid cols={isMobile ? 1 : 2}>
          {options?.descriptionArray?.map((description, index) => {
            return (
              <Stack key={index} spacing={4}>
                {description.title && (
                  <Text
                    style={{
                      ...descriptionTitleStyle,
                      ...(footerStyles?.description?.title || {}),
                    }}
                  >
                    {description.title}
                  </Text>
                )}
                {description.text && (
                  <Stack spacing={0}>
                    {description.text?.map((txt, idx) => (
                      <Text
                        key={idx}
                        style={{
                          ...descriptionTextStyle,
                          ...(footerStyles?.description.text || {}),
                        }}
                      >
                        {txt}
                      </Text>
                    ))}
                  </Stack>
                )}
              </Stack>
            );
          })}
        </SimpleGrid>
        <Stack w={"auto"} spacing={16}>
          {options?.contactInfoArray?.map(
            ({ title, infoArray, infoSpacing }, index) => {
              return (
                <div
                  style={{
                    ...connectItemWrapperStyle,
                    ...(footerStyles?.connectWrapperStyle?.connectItemWrapperStyle || {}),
                  }}
                  key={index}
                >
                  <Text
                    style={{
                      ...descriptionTitleStyle,
                      ...(footerStyles?.contact?.title || {}),
                    }}
                  >
                    {title}
                  </Text>
                  <Group noWrap spacing={infoSpacing || 40}>
                    {infoArray?.map(({ href, image, target }, infoIndex) => {
                      return (
                        <Link href={href} key={infoIndex} target={target}>
                          {" "}
                          <Image
                            alt=""
                            fit="fill"
                            src={image?.src}
                            width={image?.width || 36}
                            height={image?.height || 36}
                          />
                        </Link>
                      );
                    })}
                  </Group>
                </div>
              );
            },
          )}
        </Stack>
      </Flex>
    </div>
  );
}
